import { ReactNode } from 'react';

import DeviceGroupContext, { DeviceGroupContextValue } from './deviceGroupContext';

const DeviceGroupProvider = ({
	value,
	children,
}: {
	value: DeviceGroupContextValue;
	children: ReactNode;
}) => {
	return <DeviceGroupContext value={value}>{children}</DeviceGroupContext>;
};

export default DeviceGroupProvider;
